<template>

    <invoices
        :invoices-uri="route('api.v1.financial.invoices.index')"
        :add-invoice-uri="route('api.v1.financial.invoices.add')"
    ></invoices>

</template>

<script>

import Invoices from "../../components/Business/Invoices";

export default {

    components: {
        Invoices,
    },

    metaInfo: {
        title:'Invoices',
    },

    name:'FinancialInvoices',

}

</script>
